export default {
  // Common labels used in multiple modules
  'global.advertisement': 'pubblicità',
  'global.cancel': 'Annulla',
  'global.confirm': 'Conferma',
  'global.continue': 'Continua',
  'global.continue.title': 'Sei sicuro di voler procedere?',
  'global.newsletter': 'Newsletter',
  'global.video': 'Video',

  // Preact AudioPlayer component
  'audio.listen.text': 'ascolta articolo',
  'audio.player.not.active': 'player non attivo',

  // Preact BannerPrivacy component
  'bannerPrivacy.confirmText': 'OK',
  'bannerPrivacy.text':
    "Se prosegui con la navigazione o clicchi OK acconsenti all'uso da parte di Sky dei cookie tecnici, analitici, di profilazione di prima e terza parte, che sono usati per capire i contenuti che ti interessano e inviarti pubblicità in linea con le tue preferenze. Se vuoi saperne di più sui cookie e su come puoi disattivarli leggi ",
  'bannerPrivacy.text2': "la nostra Cookie Policy. Per leggere l'Informativa Privacy clicca ",
  'bannerPrivacy.textClickHere': 'qui',

  // ModalPrivacy component
  'modal.privacy.title': 'Informativa privacy',

  // Preact Parsely widget common labels
  'parsely.common.privacy.cancel.consent': 'Revoca consenso privacy',
  'parsely.common.show.preference.news': '%s: vedi tutte',

  // Preact LoginCard Component
  'parsely.login.enter': 'Fai login',
  'parsely.login.mylocalnews.card.text': 'Scopri subito le ultime news della tua regione. Personalizza la home.',

  // Preact Parsely MyLocalNews widget
  'parsely.mylocalnews.dropdown.message.deselect': 'Per tornare alle <b>%s</b> deseleziona la regione',
  'parsely.mylocalnews.dropdown.message.select': "Seleziona una regione dall'elenco e conferma",
  'parsely.mylocalnews.tag.default.text': 'Scegli la tua regione',

  // Preact Parsely MySport widget
  'parsely.mysport.dropdown.message.select.0': 'Puoi scegliere un massimo di <b>3 sport</b>',
  'parsely.mysport.dropdown.message.select.1': 'Puoi scegliere ancora <b>2 sport</b> e confermare',
  'parsely.mysport.dropdown.message.select.2': 'Puoi scegliere ancora <b>1 sport</b> e confermare',
  'parsely.mysport.dropdown.message.select.3': 'Hai scelto <b>3 sport.</b> Conferma!',
  'parsely.mysport.dropdown.title': '',
  'parsely.mysport.login.card.text': 'Ora puoi personalizzare questo spazio con le notizie dei tuoi sport preferiti',
  'parsely.mysport.tag.default.text': 'Scegli i tuoi sport',
  'parsely.mysport.tag.edit.text': 'Modifica sport',

  // Preact Parsely MyTeam widget
  'parsely.myteam.dropdown.message.deselect': 'Per tornare a <b>%s</b> deseleziona la squadra',
  'parsely.myteam.dropdown.message.select': "Seleziona una squadra dall'elenco e conferma",
  'parsely.myteam.login.card.text': 'Scopri subito le ultime news sulla tua squadra. Personalizza la home.',
  'parsely.myteam.tag.default.desktop.text': 'Scegli Squadra',
  'parsely.myteam.tag.default.mobile.text': 'Scegli la tua Squadra',
  'parsely.myteam.tag.default.opened.text': 'Scegli la tua Squadra',

  // parsely-render module
  'parsely.render.section.title': 'I più visti',

  // Socials
  'socials.facebook': 'Facebook',
  'socials.twitter': 'Twitter',
  'socials.whatsapp': 'Whatsapp',
  'socials.telegram': 'Telegram',
  'socials.copy': 'Copia link',
  'social.share': 'Condividi',
  'social.copied.link': 'Link copiato',

  // video-player module
  'video.player.share.on.twitter': 'Condividi su Twitter',

  // video-playlist module
  'video.playlist.error': 'spiacenti si è verificato un errore',
  'video.playlist.next.video': 'Prossimo video',

  // Web Push Notifications
  'wpn.unsubscribe.title': "Revoca l'iscrizione alle notifiche",
  'wpn.confirm.dialog.title': 'Arriva sempre primo',
  'wpn.confirm.dialog.accept': 'ACCETTA',
  'wpn.confirm.dialog.cancel': 'Forse dopo',
  'wpn.sport.confirm.dialog.description':
    'Ricevi live da <strong>SkySport</strong> tutte le <strong>breaking news</strong>, le notizie sulla tua <strong>squadra del cuore</strong> e sui tuoi <strong>sport preferiti</strong>. Per accettare le notifiche devi dare il consenso.',
  'wpn.entertainment.confirm.dialog.description':
    'Ricevi live da <strong>Sky TG24</strong> tutte le news dal<strong>mondo dello spettacolo</strong>. Per accettarele notifiche devi dare il consenso.',
  'wpn.tg24.confirm.dialog.description':
    'Ricevi live da <strong>Sky TG24</strong> le breaking neews sui <strong>principali eventi</strong>Per accettare le notifiche devi dare il consenso.',
  'wpn.confirm.dialog.success.title': 'Hai impostato correttamente le tue notifiche',
  'wpn.preferences.dialog.title': 'Scegli quali notifiche ricevere',
  'wpn.preferences.dialog.myteam.select.box.show.more': 'Vedi altre squadre',
  'wpn.preferences.dialog.myteam.select.box.show.less': 'Vedi meno squadre',
  'wpn.preferences.dialog.mysports.select.box.show.more': 'Vedi altri sport',
  'wpn.preferences.dialog.mysports.select.box.show.less': 'Vedi meno sport',
  'wpn.preferences.dialog.mylocalnews.select.box.show.more': 'Vedi altre regioni',
  'wpn.preferences.dialog.mylocalnews.select.box.show.less': 'Vedi meno regioni',
  'wpn.preferences.unsub.dialog.title': 'Sei sicuro di non volere ricevere più le notifiche?',
  'wpn.preferences.unsub.sport.dialog.description':
    'Se confermi non riceverai più le notizie della tua squadra e dei tuoi sport preferiti.',
  'wpn.preferences.unsub.tg24.dialog.description':
    'Se confermi non riceverai più le notifiche con le notizie del sito Sky TG24.',
  'wpn.preferences.unsub.dialog.confirm': 'Sì, sono sicuro',
  'wpn.preferences.unsub.dialog.cancel': 'Ho cambiato idea',
  'wpn.preferences.unsub.success.dialog.title': 'Ti sei disiscritto correttamente!',
  'wpn.preferences.dialog.latestNews-v1.select.box.message': 'Ricevi le breaking news di Sky TG24',
  'wpn.preferences.dialog.latestNews-v2.select.box.message':
    'Resta sempre aggiornato. Ricevi anche le breaking news di Sky TG24.',
  'wpn.preferences.dialog.entertainment-v1.select.box.message':
    'Sei appassionato di Spettacolo? Ricevi le ultime notizie di cinema, TV, musica, moda.',
  'wpn.preferences.dialog.entertainment-v2.select.box.message': 'Ricevi le ultime notizie di cinema, TV, musica, moda.',

  // Preferences Page
  'messenger.people.title': 'Segui Sky Sport: come avere i nostri aggiornamenti',
  'mysport.confirm.label': 'conferma sport',
  'myteam.confirm.label': 'conferma squadra',
  'newsletters.select.label': 'Seleziona newsletter',
  'newsletters.confirm.label': 'conferma e iscriviti',
  'mylocalnews.confirm.label': 'conferma regione',
  'mysport.confirm.message': 'Hai selezionato <b>%s</b> sport',
  'myteam.confirm.message': 'Hai selezionato <b>%s</b> squadra',
  'mylocalnews.confirm.message': 'Hai selezionato <b>%s</b> regioni',
  'tabs.premium': 'insider',
  'tabs.personalize': 'area personale',
  'tabs.your.contents': 'i tuoi contenuti',
  'status.notification.message.WPN': 'Hai impostato correttamente le tue notifiche',
  'status.notification.message.set.myteam': 'Hai impostato correttamente la tua squadra',
  'status.notification.message.set.mysport': 'Hai impostato correttamente i tuoi sport',
  'status.notification.message.set.mylocalnews': 'Hai impostato correttamente le tue local news',
  'status.notification.message.set.newsletters': 'Ottimo! Ti sei iscritto correttamente.',
  'status.notification.message.remove.myteam': 'Hai cancellato correttamente la tua squadra',
  'status.notification.message.remove.mysport': 'Hai cancellato correttamente il tuo sport',
  'status.notification.message.remove.mylocalnews': 'Hai cancellato correttamente le tue local news',
  'status.notification.message.remove.WPN':
    'Hai cancellato correttamente le tue notifiche. Potrai impostarle nuovamente in qualsiasi momento.',
  'contents.dropdown.option.go.to.section': 'Vai alla sezione',
  'contents.dropdown.option.edit.parselyMyTeam': 'Modifica squadra',
  'contents.dropdown.option.edit.parselyMySport': 'Modifica sport',
  'contents.dropdown.option.edit.parselyMyLocalNews': 'Modifica regione',
  'you.are.following.title': 'Stai seguendo',
  'you.are.following.link.label': 'Vai alla sezione',

  // Premium
  'premium.title1': 'Sky Sport Insider',
  'premium.title2': 'Sky TG24 Insider',

  'premium.description1': 'Gestisci il piano di sottoscrizione.',
  'premium.description2':
    'Il nuovo spazio editoriale di approfondimento esclusivo: storie inedite, retroscena e opinioni raccontati dalle firme più prestigiose e dai grandi campioni della squadra di Sky Sport. <br><br> Sei interessato?',
  'premium.description3':
    'Per maggiori informazioni sul tuo piano <a href="https://assistenza.sky.it/abbonamento/faq-sky-insider" target="_blank">consulta le FAQ</a>.',
  'premium.description4':
    'Il nuovo spazio editoriale di approfondimento esclusivo firmato Sky: notizie di attualità, opinioni e punti di vista autorevoli, raccontati da giornalisti ed esperti del settore. <br><br> Sei interessato?',
  'premium.description5':
    'Il nuovo spazio editoriale di approfondimento esclusivo firmato Sky: notizie di attualità, opinioni e punti di vista autorevoli, raccontati da giornalisti ed esperti del settore. <br><br> Sky TG24 Insider è offerto da Sky Extra. Sei interessato?',
  'premium.description6':
    'Il nuovo spazio editoriale di approfondimento esclusivo: storie inedite, retroscena e opinioni raccontati dalle firme più prestigiose e dai grandi campioni della squadra di Sky Sport. <br><br> Sky Sport Insider è offerto da Sky Extra. Sei interessato?',

  // Login Bar
  'loginbar.login': 'login',
  'loginbar.logout': 'logout',

  // Video Card Inline
  'videocardinline.is.playing': 'in riproduzione',

  // Card navigator
  'cardnavigator.header': 'In questa scheda',
  'cardnavigator.index': 'Indice',

  // Disclaimer
  'disclaimer.preroll': 'Il video inizierà dopo questo breve annuncio',
  'disclaimer.redirect': 'Prossimo video in caricamento',
};
